import { themeV2, pxToEm } from '@insticator/insticator-ui';

/* ++++++++++ --------------- MY ACCOUNT PAGE : STYLES --------------- ++++++++++ */
export default theme => ({
  account: {
    '& .cardwrapper': {
      background: themeV2.color.base.white,
      maxWidth: pxToEm(1280),
      '& .content': { paddingTop: pxToEm(20) },
      '& form': { 
        width: '100%',
        '& .title': {
          '& h2': {
            fontWeight: 700,
            fontSize: pxToEm(20),
            marginBottom: pxToEm(24)
          }
        },
      }
    },
    '& .name-profileaction': {
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: pxToEm(310),
      margin: `${pxToEm(16)} 0`,
      '& .name-edit': {
        width: pxToEm(200)
      },
      '& .name-save': {
        width: pxToEm(130)
      },
      '& .name-discard': {
        width: pxToEm(170)
      }
    }
  }
})